<div [ngClass]="rootClassList" [class]="styleClass ?? ''" [ngStyle]="style ?? null">
  @if (captionTemplate) {
    <div class="p-datatable-header">
      <ng-container *ngTemplateOutlet="captionTemplate"></ng-container>
    </div>
  }

  <div class="p-datatable-wrapper" [ngStyle]="wrapperStyle">
    <table class="p-datatable-table" [class]="tableStyleClass ?? ''" [ngStyle]="tableStyle ?? null">
      @if (headerTemplate) {
        <thead class="p-datatable-thead">
          <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </thead>
      }

      <tbody class="p-datatable-tbody">
        @if (processedRows.length > 0) {
          @for (row of displayedRows; track trackByIdentity(rowIndex, row); let rowIndex = $index) {
            <ng-container
              *ngTemplateOutlet="bodyTemplate; context: bodyContext(row, rowIndex)"
            ></ng-container>
          }
        } @else {
          @if (emptyMessageTemplate) {
            <ng-container *ngTemplateOutlet="emptyMessageTemplate"></ng-container>
          } @else {
            <tr>
              <td class="p-datatable-emptymessage">No records found</td>
            </tr>
          }
        }

      </tbody>

      @if (footerTemplate) {
        <tfoot class="p-datatable-tfoot">
          <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        </tfoot>
      }
    </table>
  </div>

  @if (paginator) {
    <div class="p-paginator p-component">
      <!-- hidden material paginator for page-size + event mechanics -->
      <mat-paginator
        class="app-table-mat-paginator"
        [length]="totalRecordsResolved"
        [pageIndex]="currentPage"
        [pageSize]="rowsInternal"
        [pageSizeOptions]="rowsPerPageOptions ?? [5, 10, 25, 50]"
        (page)="onMatPage($event)"
      ></mat-paginator>
      @if (showCurrentPageReport) {
        <div class="p-paginator-left-content">
          <span class="p-paginator-current">{{ currentPageReportText }}</span>
        </div>
      }
      <div class="p-paginator-right-content">
        <button
          type="button"
          class="p-paginator-first p-paginator-element p-link"
          [disabled]="currentPage === 0"
          (click)="goToFirstPage()"
          aria-label="First Page"
          >
          <span class="p-paginator-icon pi pi-angle-double-left"></span>
        </button>
        <button
          type="button"
          class="p-paginator-prev p-paginator-element p-link"
          [disabled]="currentPage === 0"
          (click)="goToPreviousPage()"
          aria-label="Previous Page"
          >
          <span class="p-paginator-icon pi pi-angle-left"></span>
        </button>
        <span class="p-paginator-pages">
          @for (p of pageLinkNumbers; track p) {
            <button
              type="button"
              class="p-paginator-page p-paginator-element p-link"
              [class.p-highlight]="p === currentPage"
              (click)="goToPage(p)"
              >
              {{ p + 1 }}
            </button>
          }
        </span>
        <button
          type="button"
          class="p-paginator-next p-paginator-element p-link"
          [disabled]="currentPage >= pageCount - 1"
          (click)="goToNextPage()"
          aria-label="Next Page"
          >
          <span class="p-paginator-icon pi pi-angle-right"></span>
        </button>
        <button
          type="button"
          class="p-paginator-last p-paginator-element p-link"
          [disabled]="currentPage >= pageCount - 1"
          (click)="goToLastPage()"
          aria-label="Last Page"
          >
          <span class="p-paginator-icon pi pi-angle-double-right"></span>
        </button>
      </div>
    </div>
  }

  @if (summaryTemplate) {
    <div class="p-datatable-footer">
      <ng-container *ngTemplateOutlet="summaryTemplate"></ng-container>
    </div>
  }
</div>

